import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import AddUser from "./addUser";
import EditUser from "./editUser";
import { Modal } from "react-native-web";
import { useRecoilValue } from "recoil";
import { tokenState } from "../reducer";
import { apiservice } from "../service/api";
const { width, height } = Dimensions.get("window");
const manageAdmin = () => {
  const [page, setpage] = useState(0);
  const [state, setstate] = useState({});
  const [modal, setmodal] = useState(false);
  const [fill, setFill] = useState("");
  const [data1, setdata1] = useState([]);
  const token = useRecoilValue(tokenState);
  console.log("asd", token);
  async function getallUniversity() {
    const res = await apiservice({
      path: "/authen/alladmin",
      method: "get",
      token: token.accessToken,
    });
    // console.log(res.data);
    if (res.status == 200) {
      // const get = res.data.map((e) => {
      //   if (e.Type == "SUPERADMIN") {
      //     return { ...e, num: 0 };
      //   } else {
      //     return { ...e, num: 1 };
      //   }
      // });
      // // console.log("AAA", get);
      setdata1(res.data);
    }
  }

  useEffect(() => {
    getallUniversity();
  }, [token]);

  async function createUniversity() {
    const res = await apiservice({
      path: "/authen/updateadmin",
      method: "put",
      body: state,
    });
    if (res.status == 200) {
      setpage(0);
      getallUniversity();
    }
  }

  async function deleteUniversity() {
    const res = await apiservice({
      path: "/authen/deleteadmin/" + state.id,
      method: "delete",
    });
    if (res.status == 200) {
      setmodal(false);
      getallUniversity();
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบ User นี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.3,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  deleteUniversity();
                  setmodal(false);
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            ผู้ดูแลทั้งหมด
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.06,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                value={fill}
                onChangeText={setFill}
                onSubmitEditing={async () => {
                  const res = await apiservice({
                    path: "/authen/alladmin",
                    method: "get",
                    token: token.accessToken,
                  });
                  setdata1(
                    res.data.filter(
                      (items) =>
                        items.fullname.includes(fill) ||
                        items.username.includes(fill) ||
                        items.uni.name.includes(fill)
                    )
                  );
                }}
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
              />
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/authen/alladmin",
                    method: "get",
                    token: token.accessToken,
                  });
                  setdata1(
                    res.data.filter(
                      (items) =>
                        items.fullname.includes(fill) ||
                        items.username.includes(fill) ||
                        items.uni.name.includes(fill)
                    )
                  );
                }}
                style={{
                  width: width * 0.022,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                }}
              >
                <AntDesign
                  name="search1"
                  style={{ margin: "auto" }}
                  size={15}
                  color="#ffff"
                />
              </TouchableOpacity>
            </View>
            <TouchableOpacity
              onPress={() => setpage(1)}
              style={{
                width: width * 0.065,
                height: height * 0.037,
                backgroundColor: "#43A2D4",
                borderRadius: 5,
              }}
            >
              <Text style={styles.TextButton}>+ เพิ่มผู้ดูแล</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.546,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
            }}
          >
            <View
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",
                flexDirection: "row",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }}
            >
              <View style={{ width: width * 0.123, height: height * 0.054 }}>
                <Text style={styles.Textheader}>ชื่อผู้ดูแล</Text>
              </View>
              <View style={{ width: width * 0.123, height: height * 0.054 }}>
                <Text style={styles.Textheader}>ชื่อผู้ใช้งาน</Text>
              </View>
              <View style={{ width: width * 0.095, height: height * 0.054 }}>
                <Text style={styles.Textheader}>ระดับ</Text>
              </View>
              <View style={{ width: width * 0.125, height: height * 0.054 }}>
                <Text style={styles.Textheader}>มหาวิทยาลัย</Text>
              </View>
              <View style={{ width: width * 0.125, height: height * 0.054 }}>
                <Text style={styles.Textheader}>จัดการ</Text>
              </View>
            </View>

            <FlatList
              data={data1}
              renderItem={({ item, index }) => {
                // console.log("ASD", item);
                return (
                  <View
                    style={{
                      width: width * 0.591,
                      height: height * 0.046,
                      flexDirection: "row",
                      backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                    }}
                  >
                    <View
                      style={{ width: width * 0.123, height: height * 0.046 }}
                    >
                      <Text style={styles.Textdata}>{item.fullname}</Text>
                    </View>
                    <View
                      style={{ width: width * 0.123, height: height * 0.046 }}
                    >
                      <Text style={styles.Textdata}>{item.username}</Text>
                    </View>
                    <View
                      style={{ width: width * 0.095, height: height * 0.046 }}
                    >
                      <Text style={styles.Textdata}>
                        {item.Type == "SUPERADMIN" ? "Super Admin" : "Admin"}
                      </Text>
                    </View>
                    <View
                      style={{ width: width * 0.125, height: height * 0.046 }}
                    >
                      <Text style={styles.Textdata}>{item.uni.name}</Text>
                    </View>
                    <View
                      style={{
                        width: width * 0.125,
                        height: height * 0.046,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          setstate(item);
                          setpage(2);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#69D443",
                        }}
                      >
                        <Text style={styles.TextButton}>แก้ไข</Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setstate(item);
                          setmodal(true);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#D44343",
                        }}
                      >
                        <Text style={styles.TextButton}>ลบ</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>
        </View>
      )}

      {page == 1 && <AddUser />}
      {page == 2 && (
        <EditUser
          state={state}
          setState={setstate}
          createUniversity={createUniversity}
        />
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, margin: "auto", fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageAdmin;
